import type { Nullable } from '@ats/interfaces';
import { useEffect, useRef } from 'react';

type IntervalFunction = () => unknown | void;

export function useInterval(
  callback: IntervalFunction,
  delay: Nullable<number>,
) {
  const savedCallback = useRef<Nullable<IntervalFunction>>(null);

  useEffect(() => {
    if (delay === null) return;
    savedCallback.current = callback;
  });

  useEffect(() => {
    if (delay === null) return undefined;

    function tick() {
      if (savedCallback.current !== null) {
        savedCallback.current();
      }
    }

    const id = setInterval(tick, delay);

    return () => clearInterval(id);
  }, [delay]);
}
